<template>
  <b-modal
    :id="`modal-action-${action}`"
    :ref="`modal-action-${action}`"
    :title="`${title} documento`"
    data-cy="modal-action-document"
    ok-title="Cerrar"
    ok-only
    @ok="cancelProcess"
    @close="cancelProcess"
    size="lg"
  >
    <div class="mt-2">
      Estamos intentando abrir el documento para su edición
    </div>
    <div class="mt-2">
      Recuerda no cerrar y aprobar el documento hasta haber terminado de editarlo y guardarlo
    </div>
    <div class="mt-2 alert-warning">
      Cuando cierres este panel, se recargara la vista para ver el documento actualizado
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import { BModal, VBModal, VBToggle } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import { getUrlEditDocument } from '@/libs/webdav';

const currentStage = process.env.VUE_APP_AMBIENTE;

export default {
  components: {
    BModal
  },
  data() {
    return {
      error: {
        message: ''
      },
      comment: '',
      file: {},
      commentFiles: []
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser',
    ]),
  },
  methods: {
    ...mapActions('Approvals', [
      'commentFileFlow',
      'processFileFlow'
    ]),
    openEditDocumet() {
      const { token } = this.currentUser;
      const fileUrl = this.attachment.adjuntoUrl;
      const fileName = this.attachment.objetoNombre;
      const filePath = `${currentStage}/f3-${token}/${fileUrl}/:::/${fileName}`;
      const url = getUrlEditDocument(filePath, fileName);
      // console.log('editar documento', this.activeElement);
      console.log('open in ', filePath);
      window.location = url;
    },
    cancelProcess() {
      // reload page
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === `modal-action-${this.action}`) {
        console.log('Modal is about to be shown', bvEvent, modalId);
        this.openEditDocumet();
      }
    });
  },
  props: {
    action: { type: String, required: true },
    title: { type: String, required: true },
    process: { type: Boolean, required: false },
    stepId: { type: Object, required: false },
    attachment: { type: Object, required: true },
    getSign: Function,
    numPages: Number
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    'b-modal': VBModal
  },
};
</script>
